import { render, staticRenderFns } from "./GLBreakdown.vue?vue&type=template&id=768f480e&scoped=true"
import script from "./GLBreakdown.vue?vue&type=script&lang=js"
export * from "./GLBreakdown.vue?vue&type=script&lang=js"
import style0 from "./GLBreakdown.vue?vue&type=style&index=0&id=768f480e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768f480e",
  null
  
)

export default component.exports